import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';
import DirectEmailIcon from './../../assets/images/svg-icons-material-io/mail_lock_black_24dp.svg';

const HeaderEmails = () => (
  <div className="HeaderEmails">
        <section>
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar">
                <div className="container w-max2">
                    {/*Main Header*/}
                    <div className="admin-title">
                        <img src={ DirectEmailIcon } className="filter-white" alt="Secured email icon" /> <span>DIRECT EMAILS</span>
                    </div>
                    {/*Admin Menus*/}
                    <NavAdmin />
                </div>
            </nav>
        </section>
  </div>
);

HeaderEmails.defaultProps = {};

export default HeaderEmails;
